export default __webpack_public_path__ + "static/media/popup_mail.863645ee.svg";